import { render, staticRenderFns } from "./commonCompany.vue?vue&type=template&id=16f0cd4f&"
import script from "./commonCompany.vue?vue&type=script&lang=js&"
export * from "./commonCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports